import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";

export const CRM_SCHEMA = "crm";

let supabaseClient: SupabaseClient | null = null;

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    // [hiperautomacao] The CRM reads and writes only through the "crm" schema:
    // views over the instance database, gated by the seller allowlist.
    supabaseClient = createClient(
      import.meta.env.VITE_SUPABASE_URL,
      import.meta.env.VITE_SB_PUBLISHABLE_KEY,
      { db: { schema: CRM_SCHEMA } },
      // The schema only narrows the generated types; the rest of the code
      // is written against the untyped client.
    ) as unknown as SupabaseClient;
  }
  return supabaseClient;
};
